import axios from "axios";
import apiUrl from "../Config";

export const getAllShowroom = async ({ isActive, search, page, pageSize } = {}) => {
  const params = new URLSearchParams();

  if (isActive !== undefined) params.append('isActive', isActive);
  if (search) params.append('search', search);
  if (page) params.append('page', page);
  if (pageSize) params.append('pageSize', pageSize);

  const url = apiUrl+`/showroom/showRoom?${params.toString()}`;
  const response = await axios.get(url);
  return response.data;
};